// React
import React from 'react'
// Third-party libraries
import { useTranslation } from 'react-i18next'
// Material UI components
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
// Local files
import { FormatNumberMXN } from "../../common/Utils";

//Styles table
const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: '#BFBFBF',
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 12,
    },
  }))(TableCell);
  
  const StyledTableRow = withStyles((theme) => ({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

  const useStyles = makeStyles({
    table: {
      minWidth: 100,
    },
  });

const ExpandedComponent = ({ data }) => {
    //Language
    const { t } = useTranslation();

    const classes = useStyles();
    return (
        <TableContainer component={Paper} style={{padding: '0 0 0 48px'}}>
            <Table className={classes.table} size="small">
            <TableHead>
                <TableRow>
                    <StyledTableCell style={{ width: 160 }} align="center">{t('OrderDetailDashboard.ColumnVIN')}</StyledTableCell>
                    <StyledTableCell align="center">{t('OrderDetailDashboard.ColumnService')}</StyledTableCell>
                    <StyledTableCell style={{ width: 160 }} align="center">{t('OrderDetailReceipt.ColumnAmount')}</StyledTableCell>
                </TableRow>
            </TableHead>
            <TableBody>
            {data.unitServices.map((row) => (
                <StyledTableRow key={row.vin}>
                    <StyledTableCell component="th" scope="row" style={{ width: 160 }}>
                    {row.vin}
                    </StyledTableCell>
                    <StyledTableCell>{row.service}</StyledTableCell>
                    <StyledTableCell style={{ width: 160 }} align="right">{FormatNumberMXN(row.subtotal)}</StyledTableCell>
                </StyledTableRow>
                ))}
            </TableBody>
            </Table>
        </TableContainer>
    );
};
    
    export default ExpandedComponent;
    